import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import { PrimaryInsuranceType } from "../types";
import { formatZip } from "../../utils/StringHelper";
import moment from "moment";

interface PrimaryInsuranceInfoProps {
  primaryInsurance: PrimaryInsuranceType | null;
  handleSetEditing: () => void;
  claimStatus: string;
}

const PrimaryInsuranceInfo: React.FC<PrimaryInsuranceInfoProps> = ({
  primaryInsurance,
  handleSetEditing,
  claimStatus,
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="info-container">
      <Grid container>
        <Grid item xs={4}>
          <Typography className="info-heading-label">
            Insurance Information
          </Typography>
          <Typography className="info-heading-text">
            Insurance Type: {primaryInsurance?.insurance_type}
            <br />
            Program or Plan Name: {primaryInsurance?.plan_name}
            <br />
            Insurance Number: {primaryInsurance?.insurance_number}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography className="info-heading-label">
            Insured’s Name (Last, First, Middle)
          </Typography>
          <Typography className="info-heading-text">
            <>
              {primaryInsurance?.last_name}
              <br />
              {primaryInsurance?.first_name}
              <br />
              {primaryInsurance?.middle_name}
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Address</Typography>
          <Typography className="info-heading-text">
            <>
              {primaryInsurance?.address_line_1}{" "}
              {primaryInsurance?.address_line_2 &&
                `, ${primaryInsurance?.address_line_2}`}
              <br />
              {primaryInsurance?.city}
              {primaryInsurance?.city && ","} {primaryInsurance?.state}{" "}
              {formatZip(primaryInsurance?.zip)}
              <br />
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">
            Additional Details
          </Typography>
          <Typography className="info-heading-text">
            <>
              DOB: {moment(primaryInsurance?.insured_dob).format("MM/DD/YYYY")}
              <br />
              Sex: {primaryInsurance?.gender}
              <br />
              Patient’s Relationship to Insured:{" "}
              {primaryInsurance?.relationship}
            </>
          </Typography>
        </Grid>
        {claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <Grid item xs={1} display="flex" justifyContent="flex-end">
              <div className="item-icon-container" onClick={handleSetEditing}>
                <img
                  src={images.pencil_orange_icon}
                  alt="edit patient Icon"
                  className="action-icon-image"
                  style={{ width: 23, maxHeight: 23 }}
                />
              </div>
            </Grid>
          )}
      </Grid>
    </Box>
  );
};

export default PrimaryInsuranceInfo;
